import _ from "lodash";
import { boundariesField, makeBoundaryDecorations } from "./boundaries";
import { generateAnalysisDecorationFacts, loanFactsStateType } from "./misc";
import { makeStepDecorations, stepField } from "./stepper";
export function makePermissionsDecorations(view, results, annotations) {
    let stepDecos = [];
    let boundaryDecos = [];
    let actionDecos = [];
    results.forEach(res => {
        let [facts, actionFacts] = generateAnalysisDecorationFacts(res);
        let bs = makeBoundaryDecorations(view, facts, res.boundaries, annotations?.boundaries);
        let ss = makeStepDecorations(view, facts, res.steps, annotations?.stepper);
        boundaryDecos.push(bs);
        stepDecos.push(ss);
        actionDecos.push(actionFacts);
    });
    return {
        stepper: stepDecos.flat(),
        boundaries: _.uniqBy(boundaryDecos.flat(), d => d.from),
        facts: actionDecos.flat()
    };
}
export function renderPermissions(view, decorations, cfg) {
    console.debug("rendering permissions with", cfg);
    if (decorations !== undefined) {
        let useSteps = String(cfg?.stepper) === "true";
        let useBoundaries = String(cfg?.boundaries) === "true";
        view.dispatch({
            effects: [
                loanFactsStateType.of(decorations.facts),
                stepField.setEffect.of(useSteps ? decorations.stepper : []),
                boundariesField.setEffect.of(useBoundaries ? decorations.boundaries : [])
            ]
        });
    }
}
//# sourceMappingURL=permissions.js.map